import { getAuthHeaders, requireAuthentication } from './authUtils';

export interface DashboardSummary { total: number; arrivedConfirmed: number; notConfirmedYet: number; missed: number }
export interface UpcomingDay { date: string; count: number; confirmed: number }
export interface CreationEntry { date: string; clinicName: string; createdBy: string; count: number }
export interface DashboardOverview { summary: DashboardSummary; upcoming: UpcomingDay[]; activeClinics: { count: number } }
export type DashboardSection = 'summary' | 'active-clinics' | 'upcoming' | 'created-appointments' | 'draft-count';

export async function getDashboard<T>(section: DashboardSection, signal?: AbortSignal, includeOverview = false): Promise<T> {
  requireAuthentication();
  const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/admin/dashboard/${section}${includeOverview ? '?includeOverview=true' : ''}`, { headers: getAuthHeaders(), signal });
  if (!response.ok) throw new Error('לא ניתן לטעון את הנתונים. נסה שוב.');
  return response.json();
}

export async function getDashboardOverview(signal?: AbortSignal): Promise<DashboardOverview> {
  const overview = await getDashboard<DashboardOverview>('summary', signal, true);
  if (!overview || !overview.summary || !Array.isArray(overview.upcoming) || !overview.activeClinics) {
    throw new Error('לא ניתן לטעון את הנתונים. נסה שוב.');
  }
  return overview;
}
